import { Component, inject, input } from '@angular/core';
import { DevelopmentPageLineParams } from "../../types/development-page.types";
import { Clipboard } from "@angular/cdk/clipboard";
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'app-development-page-line',
  standalone: true,
  imports: [
    MatButton
  ],
  templateUrl: './development-page-line.component.html',
  styleUrl: './development-page-line.component.scss'
})
export class DevelopmentPageLineComponent {
  developmentPageLineParams = input.required<DevelopmentPageLineParams>();

  private clipboard: Clipboard = inject(Clipboard);

  public copyToClipboard(value: string | undefined): void {
    if (!value) { return; }

    this.clipboard.copy(value);
  }
}
